import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

/**
 * Properties for the copy clipboard event command sent from the database iframe to the parent.
 */
export type CopyClipboardEventCommandProperties = CommandProperties;

/**
 * Properties for the cut clipboard event command sent from the database iframe to the parent.
 */
export type CutClipboardEventCommandProperties = CommandProperties;

/**
 * Command sent from the database iframe to notify the parent application
 * of copy clipboard events that databases did not handle (empty payload case).
 *
 * This allows Whiteboards to handle the copy event when databases has nothing to copy.
 */
export const CopyClipboardEventCommand =
  createCommand<CopyClipboardEventCommandProperties>('copy-clipboard-event');

/**
 * Command sent from the database iframe to notify the parent application
 * of cut clipboard events that databases did not handle (empty payload case).
 *
 * This allows Whiteboards to handle the cut event when databases has nothing to cut.
 */
export const CutClipboardEventCommand =
  createCommand<CutClipboardEventCommandProperties>('cut-clipboard-event');
